import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Category } from '../category/category.model';
import * as fromUser from '../../user-info/store/user.reducer';
import * as fromUserInfo from '../../user-info/store/user.reducer';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {
    private static readonly SELECTED_CATEGORY_KEY =
        'main-component-selected-category';

    private selectedCategoryIdSubject = new BehaviorSubject<number | null>(
        this.getStoredSelectedCategoryId()
    );

    public categories$: Observable<Array<Category>>;
    public filteredCategories$: Observable<Category[]>;
    public selectedCategoryId$ = this.selectedCategoryIdSubject.asObservable();

    constructor(private store: Store<fromUserInfo.State>) {
        this.setupObservables();
    }

    private setupObservables() {
        this.categories$ = this.store.pipe(
            select(fromUser.getUserProcessCategories),
            map(x => x.filter(cat => !!cat.CategoryName))
        );

        this.filteredCategories$ = combineLatest([
            this.categories$,
            this.selectedCategoryId$
        ]).pipe(
            map(([categories, selectedCategoryId]) => {
                if (selectedCategoryId === null) {
                    return categories.filter(cat => !cat.IsBizProcess);
                }
                return categories.filter(
                    cat => cat.CategoryId === selectedCategoryId
                );
            })
        );
    }

    filterByCategory(categoryId: number | null) {
        this.selectedCategoryIdSubject.next(categoryId);
        this.setStoredSelectedCategoryId(categoryId);
    }

    private getStoredSelectedCategoryId(): number | null {
        try {
            const stored = localStorage.getItem(
                CategoryService.SELECTED_CATEGORY_KEY
            );
            return stored ? parseInt(stored, 10) || null : null;
        } catch (error) {
            console.warn('Error reading from localStorage:', error);
            return null;
        }
    }

    private setStoredSelectedCategoryId(categoryId: number | null): void {
        try {
            if (categoryId === null) {
                localStorage.removeItem(CategoryService.SELECTED_CATEGORY_KEY);
            } else {
                localStorage.setItem(
                    CategoryService.SELECTED_CATEGORY_KEY,
                    categoryId.toString()
                );
            }
        } catch (error) {
            console.warn('Error writing to localStorage:', error);
        }
    }

    clearSelectedCategory(): void {
        this.selectedCategoryIdSubject.next(null);
        localStorage.removeItem(CategoryService.SELECTED_CATEGORY_KEY);
    }
}
